import React from 'react';
import cn from 'classnames';

const DropdownArrow = ({ direction = 'down', onClick }) => {
  return <div className={cn('dropdown-arrow', direction)} onClick={onClick} />;
};

export default DropdownArrow;
